<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline"
              @keyup.enter.native="query">
        <a-row :gutter="24">

          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item label="事业群">
              <a-select v-model="queryParam.businessGroupId"
                        :options="businessGroupOptions"
                        placeholder="请选择事业群"
                        @change="businessGroupChange">
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item label="事业处">
              <a-select v-model="queryParam.businessUnitId"
                        :options="businessUnitOptions"
                        placeholder="请选择事业处">
              </a-select>
            </a-form-item>
          </a-col> -->

          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <span style="float: left;overflow: hidden;"
                  class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="query"
                        icon="search">查询</a-button>
              <a-button type="primary"
                        @click="searchResetCus"
                        icon="reload"
                        style="margin-left: 8px">重置</a-button>
              <a-button type="primary"
                        @click="handlerBindEmployee"
                        v-if=" selectedRowKeys2.length > 0"
                        style="margin-left: 8px">批量选择楼栋</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          &lt;!&ndash;<a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>&ndash;&gt;
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>-->

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table ref="table"
               size="middle"
               :scroll="{x:true}"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="{selectedRowKeys2: selectedRowKeys2, onChange: onSelectChange2}"
               class="j-table-force-nowrap"
               @change="handleTableChange">

        <template slot="selectAction"
                  slot-scope="text, record">
          <a v-if="record.bindState === 1"
             @click="showModal(record)">{{text}}</a>
          <a v-else-if="record.bindState === 2"
             disabled>{{text}}</a>
          <a v-else-if="record.bindState === 0"
             @click="showModal(record)">选择楼栋</a>
        </template>

        <span slot="action"
              slot-scope="text, record">
          <a v-if="record.bindState === 1"
             @click="handleDelete(record)">解绑</a>
          <a v-else-if="record.bindState === 2"
             disabled>已绑定</a>
          <a v-else-if="record.bindState === 0"
             disabled>未绑定</a>
        </span>

      </a-table>
    </div>

    <div>
      <a-button type="primary"
                @click="handlerClick"
                v-show="this.customerModel.pageState != 2">上一步</a-button>
    </div>

    <a-modal title="选择楼栋"
             :visible="visible"
             :confirm-loading="confirmLoading"
             @ok="handleOk"
             @cancel="handleCancel">
      <a-table ref="table"
               size="middle"
               :scroll="{x:true}"
               bordered
               rowKey="id"
               :columns="buildColumns"
               :dataSource="buildList"
               :pagination="false"
               :loading="loading"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type:'radio'}"
               class="j-table-force-nowrap">
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction } from '@/api/manage'
import { filterObj } from '@/utils/util'

export default {
  name: 'PreEmployeeForm',
  // mixins:[JeecgListMixin, mixinDevice],
  components: {},
  data() {
    return {
      description: '新增员工页面',
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '工号',
          align: 'center',
          dataIndex: 'employeeNo',
        },
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '事业群',
          align: 'center',
          dataIndex: 'businessGroupName',
        },
        {
          title: '事业处',
          align: 'center',
          dataIndex: 'businessUnitName',
        },
        {
          title: '选择楼栋',
          align: 'center',
          dataIndex: 'buildName',
          scopedSlots: { customRender: 'selectAction' },
        },
        {
          title: '绑定单位',
          align: 'center',
          dataIndex: 'customerName',
        },
        {
          title: '状态',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      buildColumns: [
        {
          title: '厂区',
          align: 'center',
          dataIndex: 'factoryName',
        },
        {
          title: '区域',
          align: 'center',
          dataIndex: 'areaName',
        },
        {
          title: '楼栋',
          align: 'center',
          dataIndex: 'name',
        },
      ],
      url: {
        list: '/prevent/epm/list',
        delete: '/prevent/epm/delete',
        deleteBatch: '/prevent/epm/deleteBatch',
        exportXlsUrl: '/prevent/epm/exportXls',
        importExcelUrl: 'prevent.datamaster/import-excel',
      },
      model: {},
      dictOptions: {},
      superFieldList: [],
      businessGroupOptions: [],
      businessUnitOptions: [],
      customerModel: {},
      queryParam: {},
      visible: false,
      confirmLoading: false,
      buildList: [],
      customerBuildId: '',
      employeeId: '',

      RefRecord: {},

      /* 数据源 */
      dataSource: [],
      // 表格缓存的数据 - 用来点击取消时回显数据
      cacheData: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      /* 排序参数 */
      isorter: {
        column: '',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading: false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],

      selectedRowKeys2: [],
      /* table选中records*/
      selectionRows2: [],
    }
  },
  created() {
    //  this.searchQueryCus(1);
    this.initBusinessGroup()
    this.getSuperFieldList()
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handlerBindEmployee() {
      this.visible = true
      this.getBuildList()
    },
    username() {
      return this.$store.getters.userInfo.username
    },
    add() {
      this.edit(this.modelDefault)
    },
    setModel(model) {
      this.customerModel = model
      //   this.queryParam.customerBuildId = model.customerBuildId
      console.log('PreEmployeeForm setModel : ', model)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      // this.visible = true;
    },
    submitForm() {},
    showModal(record) {
      this.selectedRowKeys = []
      ;(this.selectionRows = []), (this.RefRecord = record)
      console.log('showModal record : ', record)
      this.employeeId = record.id
      this.visible = true
      this.getBuildList()
    },

    query() {
      if (this.queryParam.businessGroupId === undefined) {
        this.$message.warning('请选择事业群事业处查询')
        return
      }
      this.searchQueryCus(1)
    },

    searchQueryCus(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      console.log('params : ', params)
      this.loading = true
      getAction(this.url.list, params)
        .then((res) => {
          if (res.success) {
            const result = res.result.records || res.result
            this.dataSource =
              result.map((v, i) => {
                v.key = i + 1
                return v
              }) || res.result
            // this.cacheData = JSON.parse(JSON.stringify(res.result.records));

            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }

            console.log('this.data==>', this.dataSource)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getQueryParams() {
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.customerId = this.customerModel.customerId

      return filterObj(param)
    },

    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      console.log(pagination)
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.searchQueryCus()
    },

    searchResetCus() {
      this.queryParam = []
      this.businessUnitOptions = []
      this.searchQueryCus(1)
    },

    handleCancel() {
      this.visible = false
    },

    handleOk() {
      console.log('handleOk customerId: ', this.customerModel.id)
      this.bindBuilding()
    },

    bindBuilding() {
      getAction('/prevent/customer/bind_employee_build', {
        employeeId:  this.employeeId,
        customerBuildId: this.customerBuildId,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.handleCancel()
          this.searchQueryCus()
          console.log('dataSource : ', this.dataSource)
          if (this.RefRecord.bindState === 0) {
            this.RefRecord.bindState = 1
          }
          this.RefRecord.buildName = this.selectionRows[0].name
          
           this.selectedRowKeys2 = []
           this.selectionRows2 = []
        }
      })
    },

    handleDelete(record) {
      const that = this
      that.$confirm({
        title: '确认解绑',
        content: '您正在进行解绑操作，确定要解除该员工与楼栋的绑定吗？',
        onOk: function () {
          getAction('/prevent/customer/unbind_employee_build', { employeeId: record.id }).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.RefRecord.bindState = 0
              that.RefRecord.buildName = ''
            }
          })
        },
      })
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      console.log('selectedRowKeys :', selectedRowKeys)
      console.log('selectionRows :', selectionRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
      this.customerBuildId = selectionRows[0].id
    },

    onSelectChange2(selectedRowKeys, selectionRows) {
      console.log('selectedRowKeys2 :', selectedRowKeys)
      console.log('selectionRows2 :', selectionRows)
      this.selectedRowKeys2 = selectedRowKeys
      this.selectionRows2 = selectionRows
      if( this.selectedRowKeys2) {
        this.employeeId =  this.selectedRowKeys2.join(',')
      }

    },
    getBuildList() {
      getAction('/prevent/building/getBuildListByIds', {
        customerBuildingIds: this.customerModel.customerBuildingIds,
      }).then((res) => {
        if (res.success) {
          this.buildList = res.result
          this.selectedRowKeys.push(this.RefRecord.customerBuildingId)
          this.customerBuildId = this.RefRecord.customerBuildingId
        }
      })
    },

    //初始化 事业群
    initBusinessGroup() {
      getAction('/sys/sysDepart/queryBusinessGroupList3', { applicationCode: 'prevent' }).then((res) => {
        if (res.success) {
          this.businessGroupOptions = res.result.map((item) => {
            let c = { label: item.departName, value: item.orgCode }
            return c
          })
        }
      })
    },

    //事业群 改变
    businessGroupChange(val) {
      if (typeof val == 'undefined') {
        this.departOptions = []
        this.classOptions = []
        return
      }
      this.$set(this.queryParam, 'businessUnitId', '')
      this.businessUnitOptions = []
      let idArr = []
      idArr.push(val)
      let idList = idArr
      postAction('/sys/sysDepart/getBusinessUnitListByPids', idList).then((res) => {
        if (res.success) {
          this.businessUnitOptions = res.result.map((item) => {
            let c = { label: item.departName, value: item.id }
            return c
          })
        }
      })
    },
    onClearSelected() {
      this.selectedRowKeys = []
      this.selectionRows = []
    },

    handlerClick() {
      console.log('handlerClick customerModel : ', this.customerModel)
      this.$emit('handlerLastPage', this.customerModel)
    },

    getQueryField() {
      //TODO 字段权限控制
      var str = 'id,'
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex
      })
      return str
    },

    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'propertyCorporation', text: '物业公司法人', dictCode: '' })
      fieldList.push({ type: 'string', value: 'propertyName', text: '物业单位名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'corporation', text: '公司法人', dictCode: '' })
      fieldList.push({ type: 'string', value: 'name', text: '单位名称', dictCode: '' })
      fieldList.push({ type: 'int', value: 'status', text: '是否启用', dictCode: '' })
      fieldList.push({ type: 'string', value: 'principalId', text: '负责人用户ID', dictCode: '' })
      fieldList.push({ type: 'string', value: 'delFlag', text: '是否删除', dictCode: '' })
      this.superFieldList = fieldList
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
